<template>
    <div class="wrapper">
      <div class="content-container">
        <div class="stingy-card">
          <h2>🎩 RRSP Mysteries Unraveled! 🐱‍🏍</h2>
  
          <p>Be careful with your contributions! </p>
  
          <p>Think of your RRSP as a magical treasure chest where your gold coins (earnings) can grow, shielded from the tax dragons! But beware, overfilling your chest could summon the penalty gremlins! Here's the wizardry behind it:</p>
      <ul>
        <li>Your RRSP limit is like a magic bag - it can hold up to 18% of your last year's earnings or $29,210 (whichever is lesser), but remember, it shrinks if you have a pension plan!</li>
        <li>Contribute by March 1, 2023, for the 2022 tax year - it's like casting a spell to reduce your taxes!</li>
        <li>Overcontribute, and the gremlins will demand 1% per month as tribute!</li>
      </ul>
      <p>🧙‍♂️ Want to know your limit? Check your latest notice of assessment from the CRA, it's like a scroll of knowledge!</p>
   

    <div class="tfsa-info">
      <h2>🌟 TFSA: Your Magical Money-Growing Pot! 🌱</h2>
      <p>Imagine a pot where you plant money seeds (contributions), and they grow tax-free! Withdraw your blossomed funds anytime, and the space it occupied magically clears for next year's planting!</p>
      <table>
        <!-- Table of TFSA Contribution Limits -->
      </table>
      <p>📈 Fun fact: When you withdraw, say, a grown money tree, you can replant an even bigger one next year, equal to this year's withdrawal!</p>
    </div>
  </div> </div></div>
</template>


<script>
</script>



<style scoped>
.wrapper {
display: flex;
flex-direction: column;
align-items: center;
}

.content-container {
background-color: #4A148C ;  /* Light orange color */
color: black;
padding: 20px;
border-radius: 20px;  /* Adjust this value to your preference */
overflow: hidden; 
}
.stingy-card {
flex: 1;  /* Take up equal width as the iframe */
padding: 20px;
border-radius: 8px;
box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
background-color: white
}

.stylish-links {
background: linear-gradient(90deg, rgba(255,255,255,1) 0%, rgba(240,240,240,1) 100%);
padding: 20px;
border-radius: 10px;
box-shadow: 0 4px 6px rgba(0,0,0,0.1);
}

.stylish-links h3 {
color: #333;
font-size: 1.4em;
margin-bottom: 15px;
}

.stylish-links ul {
list-style: none;
padding: 0;
}

.stylish-links ul li {
background-color: #fff;
margin: 10px 0;
padding: 10px;
border-radius: 8px;
box-shadow: 0 2px 4px rgba(0,0,0,0.1);
transition: all 0.3s ease;
}

.stylish-links ul li a {
color: black;
text-decoration: none;
font-weight: bold;
}

.stylish-links ul li:hover {
background-color: #4A148C;
}

.stylish-links ul li:hover a {
color: #fff;
}
</style>